import { ActionIcon, Tooltip } from '@mantine/core';
import { useAtom } from 'jotai';
import { expandOrCollapseAllAtom } from '~/atoms/no-code-atoms';
import { IconLayoutBottombarCollapseFilled, IconLayoutNavbarCollapseFilled } from '@tabler/icons-react';
import { SearchBar } from './SearchBar';

export default function ReadOnlyControlBar({ className }: { className?: string }) {
  const [expandOrCollapseAll, setExpandOrCollapseAll] = useAtom(expandOrCollapseAllAtom);

  return (
    <div className={className}>
      <div className="flex items-center gap-4 px-2 py-4">
        <div className="flex-1">
          <SearchBar />
        </div>
        <Tooltip label={expandOrCollapseAll == 'expand' ? 'Collapse all steps' : 'Expand all steps'}>
          <ActionIcon
            variant="subtle"
            size="md"
            color="gray"
            onClick={() => {
              setExpandOrCollapseAll((prev) => (prev == 'expand' ? 'collapse' : 'expand'));
            }}
          >
            {expandOrCollapseAll == 'expand' ?
              <IconLayoutBottombarCollapseFilled size={20} />
            : <IconLayoutNavbarCollapseFilled size={20} />}
          </ActionIcon>
        </Tooltip>
      </div>
    </div>
  );
}
